import React from 'react';
import PropTypes from 'prop-types';
import { IconDownload } from '../../components';

import css from './BookingPanel.module.css';

const UploadedFiles = props => {
  const { currentTransaction, isProvider } = props;

  const invoice = currentTransaction?.attributes?.metadata?.invoice?.[0] ||
    currentTransaction?.attributes?.protectedData?.invoice?.[0];

  const contract = currentTransaction?.attributes?.metadata?.contract?.[0] ||
    currentTransaction?.attributes?.protectedData?.contract?.[0];

  const signedContract = currentTransaction?.attributes?.metadata?.signedContract?.[0] ||
    currentTransaction?.attributes?.protectedData?.signedContract?.[0];

  if (!invoice && !contract && !signedContract) return null;

  return (
    <div className={css.filesHolder}>
      {invoice && (
        <div className={css.filesItem}>
          <span>Download invoice</span>
          <a href={`${invoice.href}`} download target="_blank"> <IconDownload /> </a>
        </div>
      )}

      {contract && !signedContract && !isProvider && (
        <div className={css.filesItem}>
          <span>Download contract</span>
          <a href={`${contract.href}`} download target="_blank"> <IconDownload /> </a>
        </div>
      )}

      {signedContract && (
        <div className={css.filesItem}>
          <span>Download contract</span>
          <a href={`${signedContract.href}`} download target="_blank"> <IconDownload /> </a>
        </div>
      )}
    </div>
  );
};

UploadedFiles.defaultProps = {
  rootClassName: null,
  className: null,
};

const { string } = PropTypes;

UploadedFiles.propTypes = {
  rootClassName: string,
  className: string,
};

export default UploadedFiles;
